// DS1.5
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import LogoGreen from './Logo.dabirthday_24.green';
import LogoLight from './Logo.dabirthday_24.light';
import LogoDark from './Logo.dabirthday_24.dark';
const Logo = (_param)=>{
    var { themeVariant } = _param, props = _object_without_properties(_param, [
        "themeVariant"
    ]);
    switch(themeVariant){
        case ThemeOptions.LIGHT:
            return /*#__PURE__*/ React.createElement(LogoLight, props);
        case ThemeOptions.DARK:
            return /*#__PURE__*/ React.createElement(LogoDark, props);
        case 'green':
        default:
            return /*#__PURE__*/ React.createElement(LogoGreen, props);
    }
};
Logo.displayName = 'Logo';
export default Logo;

//# sourceMappingURL=Logo.dabirthday_24.js.map